export default __webpack_public_path__ + "static/media/brand_edenred.e2df2654.svg";